import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { TermsComponent } from './terms/terms.component';
import { InfoEfosComponent } from './info-efos/info-efos.component';
import { VaultComponent } from './vault/vault.component';
import { AccountStatementComponent } from './account-statement/account-statement.component';
import { IndicatorsComponent } from './indicators/indicators.component';
import { SuppliersComponent } from './suppliers/suppliers.component';
import { SapDocumentsComponent } from './sap-documents/sap-documents.component';
import { PolicyComponent } from './policy/policy.component';
import { CallbackComponent } from './callback/callback.component';
import { LoginComponent } from './authentication/login/login.component';


export const routes: Routes = [
  { path: 'callback/:lt', component: CallbackComponent, pathMatch: 'full' },
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', redirectTo: '/authentication/login', pathMatch: 'full' },
      { path: 'starter', loadChildren: './starter/starter.module#StarterModule' },
      { path: 'connections', loadChildren: './connection-foreign/connection-foreign.module#ConnectionForeignModule' },
      { path: 'documents', loadChildren: './documents/documents.module#DocumentsModule' },
      { path: 'log', loadChildren: './log/log.module#LogModule' },
      { path: 'repositories', loadChildren: './repositories/repositories.module#RepositoriesModule' },
      { path: 'upload', loadChildren: './uploads/uploads.module#UploadsModule' },
      { path: 'efos', loadChildren: './EFOSuploads/EFOSuploads.module#EFOSUploadsModule' },
      { path: 'vault', loadChildren: './vault/vault.module#VaultModule' },
      { path: 'account-statement', loadChildren: './account-statement/account-statement.module#AccountStatementModule' },
      { path: 'Indicators', loadChildren: './indicators/indicators.module#IndicatorsModule' },
      { path: 'suppliers', loadChildren: './suppliers/suppliers.module#SuppliersModule' },
      { path: 'sap-documents', loadChildren: './sap-documents/sap-documents.module#SapDocumentsModule' },
      { path: 'kardex', loadChildren: './kardex/kardex.module#KardexModule' },
      { path: 'accounting', loadChildren: './accounting/accounting.module#AccountingModule' },
      { path: 'conta-e-fiscal', loadChildren: './conta-e-fiscal/conta-e-fiscal.module#ContaEFiscalModule' },
      { path: 'settings', loadChildren: './settings/settings.module#SettingsModule' },
      { path: 'papers', loadChildren: './papers/papers.module#PapersModule' },
      { path: 'pagos-ppd', loadChildren: './pagos-ppd/pagos-ppd.module#PagosPpdModule' },
      { path: 'pagos-pue', loadChildren: './pagos-pue/pagos-pue.module#PagosPueModule' },
      { path: 'reports', loadChildren: './reports/reports.module#ReportsModule' },
      { path: 'vault-sat', loadChildren: './vault-sat/vault-sat.module#VaultSatModule' },
      { path: 'partners', loadChildren: './partners/partners.module#PartnersModule' },
      { path: 'payroll-layout', loadChildren: './payroll-layout/payroll-layout.module#PayrollLayoutModule' },
      { path: 'payroll', loadChildren: './payroll/payroll.module#PayrollModule' },
      { path: 'vault-history', loadChildren: './vault-history/vault-history.module#VaultHistoryModule' },
      { path: 'sat-downloads', loadChildren: './sat-downloads/sat-downloads.module#SatDownloadsModule' },
      { path: 'sync-reconciliation-monitor', loadChildren: './sync-reconciliation-monitor/sync-reconciliation-monitor.module#SyncReconciliationMonitorModule' },
      { path: 'sync-log', loadChildren: './sync-log/sync-log.module#SyncLogModule' },
      { path: 'mail-reception', loadChildren: './mail-recepcion/mail-recepcion.module#MailRecepcionModule' }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  { path: 'terms', component: TermsComponent },
  {
    path: 'policy',
    component: PolicyComponent,
  },
  { path: 'infoefos', component: InfoEfosComponent },
  {
    path: '**',
    redirectTo: '404'
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgbModule.forRoot()],
  exports: [RouterModule]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts